import axios from 'axios';
import { apiUrl } from '../Config';


const getAuthToken = () => {
    return localStorage.getItem('token') || localStorage.getItem('authToken');
}

export const getJobs = async (filters = {}) => {
    try {
        const token = getAuthToken();

        const { status, title, location, search } = filters || {};
        const params = {};

        if (status) {
            params.status = status.toLowerCase() === 'open' ? 'active' : status.toLowerCase();
        }
        if (title) params.title = title;
        if (location) params.location = location;
        if (search) params.search = search;

        const response = await axios.get(
            `${apiUrl}/jobs/getalljobs`, {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true,
            params,
        },
        );
        return response.data;
    } catch (error) {
        console.error('Error fetching jobs:', error);
        throw error;
    }
}


export const getJobById = async (jobId) => {
    try {
        const token = getAuthToken();
        const response = await axios.get(`${apiUrl}/jobs/getjob/${jobId}`, { headers: { Authorization: `Bearer ${token}` } });
        return response.data;
    } catch (error) {
        console.error('Error fetching job by id:', error);
        throw error;
    }
}


export const updateJobs = async (jobId, job) => {
    try {
        const token = getAuthToken();
        const response = await axios.put(`${apiUrl}/jobs/${jobId}`, job, { headers: { Authorization: `Bearer ${token}` } });
        return response.data;
    } catch (error) {
        console.error('Error updating job:', error);
        throw error;
    }
}

export const updateJobStatusApi = async (jobId, status) => {
    try {
        const token = getAuthToken();
        const response = await axios.put(`${apiUrl}/jobs/update-status/${jobId}`, { status }, { headers: { Authorization: `Bearer ${token}` } });
        return response.data;
    } catch (error) {
        console.error('Error updating job status:', error);
        throw error;
    }
}



export const createNewJob = async (job) => {
    try {
        const token = getAuthToken();

        const response = await axios.post(
            `${apiUrl}/jobs`, job,
            { headers: { Authorization: `Bearer ${token}` }, withCredentials: true },
        );
        return response.data;
    } catch (error) {
        console.error('Error creating job:', error);
        throw error;
    }
}


export const DeleteJobs = async (jobId) => {
    try {
        const token = getAuthToken();
        const response = await axios.delete(`${apiUrl}/jobs/${jobId}`, { headers: { Authorization: `Bearer ${token}` } });
        return response.data;
    } catch (error) {
        console.error('Error deleting job:', error.response?.data?.message || error.message);
        throw error.response?.data?.message || error.message;
    }
}

export const downloadJobs = async (jobIds = []) => {
    try {
        const token = getAuthToken();
        const response = await axios.get(
            `${apiUrl}/jobs/download`,
            {
                headers: { Authorization: `Bearer ${token}` },
                withCredentials: true,
                params: {
                    jobIds: Array.isArray(jobIds) ? jobIds.join(',') : jobIds
                },
                responseType: 'blob'
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error downloading jobs:', error.response?.data?.message || error.message);
        throw error;
    }
}

export const getActiveLocations = async () => {
    try {
        const token = getAuthToken();
        const response = await axios.get(`${apiUrl}/locations/locations`, { headers: { Authorization: `Bearer ${token}` } });
        return response.data;
    } catch (error) {
        console.error('Error fetching active locations:', error);
        throw error;
    }
};

